import type {CommonProps} from './types';

const DownChevronMedium = ({
  color = 'currentColor',
  size = 12,
  ...rest
}: CommonProps) => (
  <svg aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox="0 0 12 8"
    {...rest}
  >
    <path
      d="M1 1.5l5 5 5-5"
      stroke={color}
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DownChevronMedium;
